// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__Py__V","savePackageButton":"ClientWallet_savePackageButton__2ncCa"};